import { getFirstLetter } from '@Shared/Helpers/Utilities.js';
import SvgIcon from '@Shared/Ui/SvgIcon';
import Image from '@Shared/Ui/Image';
import PropTypes from 'prop-types';

function Button({
    testid = 'button',
    className = '',
    containerType = 'main',
    icon = '',
    onlyIcon = false,
    size = 'medium',
    autoHiddenName = false,
    disabled,
    onlyFirstLatter = false,
    width = 24,
    height = 24,
    iconCollectionName = '',
    name,
    reverse = false,
    showContentWhenIcon = false,
    btnType = 'submit',
    iconColor = '',
    iconColorHex = '',
    imgClassName = '',
    nameClassName = '',
    ...rest
}) {
    const getIconColor = () => {
        switch (containerType) {
            case 'main':
                return 'text-text-white';
            case 'second':
                return 'text-text-highlight group-hover:text-text-white';
            case 'white':
                return 'bg-white text-primary-blue';
            case 'tertiary':
                return 'group-hover:text-primary-button-selection text-primary-blue';
            case 'yellow':
                return 'text-yellow';
            case 'danger-tertiary':
                return 'text-error-main';
            default:
                return '';
        }
    };

    const isDisabled = disabled
        ? '!bg-inactive border-transparent cursor-not-allowed !text-text-disabled hover:!text-text-disabled active:!border-transparent'
        : '';

    const getSize = () => {
        if (onlyIcon && size === 'large') {
            return '!size-9 !p-0';
        } else if (onlyIcon && size === 'extra-large') {
            return '!size-10 !p-0';
        } else if (onlyIcon && size === 'small') {
            return '!h-6 !w-6 !p-0';
        } else if (onlyIcon) {
            return '!size-8 !p-0';
        } else if (size === 'medium') {
            return 'h-8 text-sm';
        } else if (size === 'large') {
            return '!h-9 text-sm';
        } else if (size === 'extra-large') {
            return '!h-10 text-base font-medium';
        }
    };
    const getType = () => {
        switch (containerType) {
            case 'main':
                return 'bg-primary-button-main hover:bg-primary-button-hover text-text-white border-transparent active:border-focus';
            case 'yellow':
                return 'text-text-yellow bg-surface-yellow hover:bg-primary-yellow hover:text-text-white border-transparent active:border-focus';
            case 'white':
                return 'text-primary-blue font-medium font-semibold bg-white border-transparent hover:border-gray-200 active:border-focus';
            case 'second':
                return 'bg-surface-light text-text-highlight hover:bg-primary-button-main hover:text-text-white border-primary-blue hover:border-transparent active:border-focus';
            case 'second-outline':
                return 'bg-surface-light text-text-highlight hover:bg-primary-button-main hover:text-text-white border-transparent hover:border-transparent active:border-focus';
            case 'tertiary':
                return `text-text-highlight hover:bg-hover border-transparent hover:bg-hover text-primary-blue  active:border-focus ${onlyIcon ? 'bg-preview-body hover:bg-hover ' : ''}`;
            case 'danger':
                return 'text-text-white bg-error-main hover:bg-error-dark border-transparent active:border-error-light';
            case 'danger-second':
                return 'text-error-main hover:text-text-white hover:bg-error-main border-error-main active:border-error-light';
            case 'danger-tertiary':
                return `text-error-main bg-surface-light hover:bg-text-text-white hover:bg-surface-error border-transparent active:border-error-light ${onlyIcon ? 'bg-error-light' : ''}`;
            default:
                return 'bg-primary-button-main hover:bg-primary-button-hover text-text-white border-transparent active:border-focus';
        }
    };

    return (
        <button
            type={btnType}
            data-testid={testid}
            className={`${disabled ? 'pointer-events-none' : 'group'} flex min-h-6 cursor-pointer ${reverse ? 'flex-row-reverse' : ''} items-center justify-center gap-2 rounded-lg border border-solid px-3 ${getType()} ${getSize()} ${isDisabled} ${className} `}
            {...rest}
        >
            {icon ? (
                iconCollectionName ? (
                    <SvgIcon iconId={icon} collectionName={iconCollectionName} />
                ) : (
                    <Image
                        style={{ color: iconColorHex }}
                        icon={icon}
                        className={`w-${width / 4} h-${height / 4} ${iconColor} min-h-${height / 4} min-w-${width / 4} ${getIconColor()} ${disabled ? '!text-text-disabled' : ''} ${imgClassName}`}
                    />
                )
            ) : null}
            {onlyFirstLatter && typeof name === 'string' ? (
                <div>{getFirstLetter(name)}</div>
            ) : showContentWhenIcon || !onlyIcon ? (
                <div
                    className={`${nameClassName} ${icon && autoHiddenName ? 'hidden md:block' : ''}`}
                >
                    {name}
                </div>
            ) : null}
        </button>
    );
}

Button.propTypes = {
    className: PropTypes.string,
    containerType: PropTypes.oneOf([
        'main',
        'second',
        'white',
        'second-outline',
        'tertiary',
        'danger',
        'danger-second',
        'danger-tertiary',
        'yellow',
    ]),
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.any]),
    icon: PropTypes.string,
    iconColor: PropTypes.string,
    nameClassName: PropTypes.string,
    imgClassName: PropTypes.string,
    onlyIcon: PropTypes.bool,
    size: PropTypes.oneOf(['medium', 'large', 'small', 'extra-large', 'extra-small']),
    autoHiddenName: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default Button;
